export const FIELD_MOVEMENT_INFO_LABEL = {
  EMPLOYEE: 'Employee',
  VEHICLE: 'Vehicle',
  LOGIN: 'Login ID',
  DEVICE: 'Device',
  STATUS: 'Status',
  SPEED: 'Speed',
  REMAINING: 'Remaining',
  LEG: 'Leg',
  UPDATED: 'Updated',
  HALT_UNTIL: 'Halt until',
  ADDRESS: 'Address',
  POINT: 'Meeting point',
};

export const FFM_FIELD_TRIGGER = {
  IDLE: 'IDLE',
  INPROGRESS: 'INPROGRESS',
  START: 'START',
};

export const FFM_FIELD_TRIGGER_LABEL = {
  [FFM_FIELD_TRIGGER.IDLE]: 'Idle',
  [FFM_FIELD_TRIGGER.INPROGRESS]: 'In progress',
  [FFM_FIELD_TRIGGER.START]: 'Start',
};

export const FFM_FIELD_TRIGGER_POLL_MS = 2000;

export const FIELD_MOVEMENT_STATUS = {
  ACTIVE: 'active',
  HALTED: 'halted',
  COMPLETED: 'completed',
  PENDING: 'pending',
};

export const FIELD_MOVEMENT_STATUS_LABEL = {
  [FIELD_MOVEMENT_STATUS.ACTIVE]: 'Moving',
  [FIELD_MOVEMENT_STATUS.HALTED]: 'Halted',
  [FIELD_MOVEMENT_STATUS.COMPLETED]: 'Completed',
  [FIELD_MOVEMENT_STATUS.PENDING]: 'Pending',
};

export const FIELD_MOVEMENT_STATUS_COLOR = {
  [FIELD_MOVEMENT_STATUS.ACTIVE]: '#20b24f',
  [FIELD_MOVEMENT_STATUS.HALTED]: '#f7941e',
  [FIELD_MOVEMENT_STATUS.COMPLETED]: '#606060',
  [FIELD_MOVEMENT_STATUS.PENDING]: '#1278fc',
};

export const FIELD_MOVEMENT_DEFAULT_VIEW = {
  LAT: 28.58,
  LON: 77.3,
  ZOOM: 12,
};

export const FIELD_MOVEMENT_STREET_ZOOM = 16;

export const FIELD_MOVEMENT_HISTORY_WINDOW_SECONDS_BY_ZOOM = {
  3: 21600, // 6h — world / India
  4: 14400, // 4h
  5: 10800, // 3h
  6: 7200, // 2h — multi-state
  7: 5400, // 1.5h
  8: 3600, // 1h
  9: 1800, // 30m — state
  10: 900, // 15m
  11: 600, // 10m
  12: 300, // 5m — city
  13: 120, // 2m
  14: 60, // 1m
  15: 20, // neighbourhood
  16: 10, // street / road — selected rider
  17: 10,
  18: 10,
  19: 10,
  20: 10,
  21: 10,
  22: 10, // building
};

export const FIELD_MOVEMENT_HISTORY_WINDOW = {
  MIN_ZOOM: 3,
  MAX_ZOOM: 22,
  DEFAULT_SECONDS: 300,
  FETCH_MIN_ZOOM: 12,
  DEBOUNCE_MS: 700,
  BOUNDS_PAD_RATIO: 0.2,
  BOUNDS_PAD_RATIO_CLOSE: 0.55,
  BOUNDS_PAD_MIN_DEG: 0.002,
  BOUNDS_PAD_MIN_DEG_CLOSE: 0.008,
  CLOSE_ZOOM: 15,
  CENTER_FALLBACK_RADIUS_M: 800,
};

export const FIELD_MOVEMENT_STATUS_POLL_MS = 10000;

export const FIELD_MOVEMENT_BULK_LOCATION_PARAMS = {
  EMP_IDS: 'emp_ids',
  BRANCH_ID: 'branch_id',
  LGD_STATE_CODE: 'lgd_state_code',
  LGD_DISTRICT_CODE: 'lgd_district_code',
  MOVEMENT_STATUS: 'movement_status',
  INTERVAL_TIME: 'interval_time',
};

export const FIELD_MOVEMENT_BULK_MOVEMENT_STATUS = {
  MOVING: 'MOVING',
  HALTED: 'HALTED',
  COMPLETED: 'COMPLETED',
};

export const FIELD_MOVEMENT_MARKER_ZOOM_SCALE = {
  MIN_ZOOM: 5,
  MAX_ZOOM: 13,
  MIN_SCALE: 0.5,
  MAX_SCALE: 1,
};

export const FIELD_MOVEMENT_MAP_STYLES = [
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.business',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.attraction',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.school',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.medical',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.place_of_worship',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.sports_complex',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'landscape',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
];

export const FIELD_MOVEMENT_TRAIL_WEIGHT = 4;

export const FIELD_MOVEMENT_PLANNED_ROUTE = {
  WEIGHT: 3,
  OPACITY: 0.5,
  DASH: [10, 8],
};

export const FIELD_MOVEMENT_START_MARKER = {
  WIDTH: 14,
  HEIGHT: 14,
  LABEL: 'Start',
  FILL_COLOR: '#20b24f',
  STROKE_COLOR: '#ffffff',
  STROKE_WEIGHT: 2,
};

export const FIELD_MOVEMENT_MEETING_STATION = {
  LABEL: 'Meeting station',
  SCALE: 9,
  STROKE_WEIGHT: 2,
  Z_INDEX: 60,
};

export const FIELD_MOVEMENT_BIKE_MARKER_VARIANTS = {
  DETAILED: 'detailed',
  RIDER: 'rider',
  SCOOTER: 'scooter',
};

export const FIELD_MOVEMENT_BIKE_MARKER_VARIANT = FIELD_MOVEMENT_BIKE_MARKER_VARIANTS.SCOOTER;

export const FIELD_MOVEMENT_SCOOTER_HEADING_OFFSET = 180;

export const FIELD_MOVEMENT_SCOOTER_DRAW_SIZE = {
  WIDTH: 88,
  HEIGHT: 88,
};

export const FIELD_MOVEMENT_SCOOTER_BODY_TINT = {
  MIN_ALPHA: 40,
  MIN_RED: 140,
  MIN_RED_MINUS_BLUE: 40,
  MAX_NEUTRAL: 200,
};

export const FIELD_MOVEMENT_MARKER_OPTIMIZED = false;

export const FIELD_MOVEMENT_MARKER_SIZE_BY_VARIANT = {
  [FIELD_MOVEMENT_BIKE_MARKER_VARIANTS.DETAILED]: {
    WIDTH: 64,
    HEIGHT: 64,
    ANCHOR_X: 32,
    ANCHOR_Y: 32,
  },
  [FIELD_MOVEMENT_BIKE_MARKER_VARIANTS.RIDER]: {
    WIDTH: 64,
    HEIGHT: 64,
    ANCHOR_X: 32,
    ANCHOR_Y: 32,
  },
  [FIELD_MOVEMENT_BIKE_MARKER_VARIANTS.SCOOTER]: {
    WIDTH: 128,
    HEIGHT: 128,
    ANCHOR_X: 64,
    ANCHOR_Y: 64,
  },
};

export const FIELD_MOVEMENT_MARKER_SIZE =
  FIELD_MOVEMENT_MARKER_SIZE_BY_VARIANT[FIELD_MOVEMENT_BIKE_MARKER_VARIANT];

export const FIELD_MOVEMENT_INFO_PIXEL_OFFSET_Y_BY_VARIANT = {
  [FIELD_MOVEMENT_BIKE_MARKER_VARIANTS.DETAILED]: -8,
  [FIELD_MOVEMENT_BIKE_MARKER_VARIANTS.RIDER]: -28,
  [FIELD_MOVEMENT_BIKE_MARKER_VARIANTS.SCOOTER]: -14,
};

export const FIELD_MOVEMENT_INFO_PIXEL_OFFSET_Y =
  FIELD_MOVEMENT_INFO_PIXEL_OFFSET_Y_BY_VARIANT[FIELD_MOVEMENT_BIKE_MARKER_VARIANT];

export const FIELD_MOVEMENT_INFO_MAX_WIDTH = 220;

export const FIELD_MOVEMENT_TRAIL_COLORS = [
  '#1278fc',
  '#20b24f',
  '#f7941e',
  '#fdb72a',
  '#d42215',
  '#2d62ed',
  '#00ccf2',
  '#ff007c',
  '#0c4e8d',
];

export const FIELD_MOVEMENT_BIKE_HELMET_COLOR = '#e53935';
export const FIELD_MOVEMENT_BIKE_JACKET_COLOR = '#3ddc54';
export const FIELD_MOVEMENT_BIKE_SEAT_COLOR = '#3c3c3c';
export const FIELD_MOVEMENT_BIKE_TIRE_COLOR = '#1a1a1a';
export const FIELD_MOVEMENT_BIKE_GRIP_COLOR = '#2b2b2b';
export const FIELD_MOVEMENT_BIKE_SKIN_COLOR = '#e8b48a';
export const FIELD_MOVEMENT_BIKE_TAIL_LIGHT_COLOR = '#f5c542';
export const FIELD_MOVEMENT_BIKE_EXHAUST_COLOR = '#d5dde2';
export const FIELD_MOVEMENT_BIKE_OUTLINE_COLOR = '#ffffff';
export const FIELD_MOVEMENT_BIKE_TANK_MIX_COLOR = '#7b3fe4';
export const FIELD_MOVEMENT_RIDER_ACCENT_COLOR = '#7a1f2e';
export const FIELD_MOVEMENT_RIDER_DARK_COLOR = '#3c2415';

export const FIELD_MOVEMENT_MARKER_ANIMATION_MS = 800;

export const FIELD_MOVEMENT_MARKER_ANIMATION_MIN_MS = 280;

export const FIELD_MOVEMENT_MARKER_ANIMATION_MAX_MS = 2000;

export const FIELD_MOVEMENT_MPS_TO_KMH = 3.6;

export const FIELD_MOVEMENT_EARTH_RADIUS_M = 6371000;

export const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || '';
